import * as React from "react"

import { cn } from "@javascript/components/utils"

export type DeveloperDocsPage = {
  href: string
  title: string
}

export function DeveloperDocsNav({
  pages,
  currentHref,
  className
}: {
  pages: DeveloperDocsPage[]
  currentHref: string
  className?: string
}) {
  return (
    <nav
      data-slot="developer-docs-nav"
      aria-label="Documentation pages"
      className={cn("flex flex-col gap-1", className)}
    >
      {pages.map((page) => {
        const isCurrent = page.href === currentHref

        return (
          <a
            key={page.href}
            href={page.href}
            data-sg-visit="true"
            aria-current={isCurrent ? "page" : undefined}
            className={cn(
              "rounded-md px-3 py-2 text-sm",
              isCurrent
                ? "bg-accent font-medium text-accent-foreground"
                : "text-muted-foreground hover:bg-accent/50 hover:text-foreground"
            )}
          >
            {page.title}
          </a>
        )
      })}
    </nav>
  )
}
